// src/utils/format.js
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

dayjs.locale('ko');

export const formatDate = (date, format = 'YYYY.MM.DD') => {
  if (!date) return '';
  return dayjs(date).format(format);
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return dayjs(date).format('YYYY.MM.DD HH:mm');
};

export const formatPrice = (price) => {
  if (price === null || price === undefined) return '';
  return new Intl.NumberFormat('ko-KR').format(price) + '원';
};

export const formatPhone = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  return phone;
};

// 이미지 URL 변환 (상대 경로 → 전체 URL)
//   운영: API_URL='' → 같은 origin /uploads/... 로 동작
const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

export const getImageUrl = (url) => {
  if (!url) return '';
  // 이미 전체 URL인 경우 그대로 반환
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // 상대 경로인 경우 API URL 붙이기
  return `${API_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};
